<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="occ_details, notification_time">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle  }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-12">
        <label>{{ lang.referringDate }}</label>

        <input type="date" class="form-control" formControlName="start_date" [ngClass]="formErrorClass(createForm.controls.start_date, createFormSubmitted)">
        

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.start_date, value:createForm.controls.start_date, submitted:createFormSubmitted }"></ng-template>

      </div>

        <div class="col-md-4">
        <label>{{ lang.repeatingPeriod }}</label>
        </div>

        <div class="col-md-4">
        <input type="text" class="form-control" formControlName="period_count" [ngClass]="formErrorClass(createForm.controls.period_count, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.period_count, value:createForm.controls.period_count, submitted:createFormSubmitted }"></ng-template>

        </div>
        <div class="col-md-4">
          <select class="form-control" formControlName="period_type" [ngClass]="formErrorClass(createForm.controls.period_type, createFormSubmitted)">
            <option value="">Select Type</option>
            <option *ngFor="let type of typePeriod" [ngValue]="type.value">{{type.text}}</option>
          </select> 
          
          <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.period_type, value:createForm.controls.period_type, submitted:createFormSubmitted }"></ng-template>

  
        </div>

        <br><br>
        <div class="col-md-4">
        </div>
        

        <div class="col-md-4">{{ lang.repetitions }}<br>
          <!-- <div class="input-group">
            <div class="hidden_table"> -->
              <div class="row">
              <div class="col-md-4" style="width: 38px;">
              <span class="input-group-addon" id="basic-addon1" style="border-left:none !important;">
                <input type="radio" formControlName="repetition_option" [ngClass]="formErrorClass(createForm.controls.repetition_option, createFormSubmitted)" (change)="isChildChange(1)"  value="1" >


              </span>
            </div>
            <div class="col-md-8">
              <!-- <input type="text" class="form-control" formControlName="repetition_count" [ngClass]="formErrorClass(createForm.controls.repetition_count, createFormSubmitted)"  style="width: 133px; height: 29px;">
              </div> -->

                <input type="number" class="form-control"  formControlName="repetition_count"   style="width: 133px; height: 29px;" min="0"/>
                <ng-container *ngIf="createForm.value.repetition_option == 1">

                  <!-- <span *ngIf="(createForm.controls.repetition_count.touched || createForm.controls.repetition_count.dirty || submitted) && createForm.controls.repetition_count.errors?.required" style="color: #ff7b76;">
                    This field is Required
                </span> -->

                <div *ngIf="createFormSubmitted && createForm.hasError('range_empty')" style="color: #ff7b76; width: 150%; margin-left: -30px;">This field is Required</div>

                
              </ng-container>
              </div>


            </div>
          </div>
          
          <div class="col-md-4">{{ lang.endDate }}<br>
            <!-- <div class="input-group">
              <div class="hidden_table"> -->
                <div class="row">
                <div class="col-md-4" style="width: 38px;">
                <span class="input-group-addon" id="basic-addon1">
                  <input type="radio" formControlName="repetition_option" [ngClass]="formErrorClass(createForm.controls.repetition_option, createFormSubmitted)" (change)="isChildChange1(2)" value="2" >
                </span>
                </div>
                <div class="col-md-8">
                <input type="date" class="form-control" formControlName="repetition_date"  style="width: 133px; height: 29px;">
              </div>
               <!-- <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.repetition_date, value:createForm.controls.repetition_date, submitted:createFormSubmitted }"></ng-template>  -->
              <br>
               <!-- <span *ngIf="(createForm.controls.repetition_date.touched || createForm.controls.repetition_date.dirty || submitted) && createForm.controls.repetition_date.errors?.required" style="color: #ff7b76;">
                This field is Required1
            </span> -->

            <br><div *ngIf="createFormSubmitted &&  createForm.hasError('range1')" style="color: #ff7b76; margin-left: 20px; margin-top: -5px;">This field is Required</div>

            <div *ngIf="createForm.hasError('range')" style="color: #ff7b76;">{{ lang.mustbegreater }}
            </div>



            </div>
          </div>
 
    
      <div class="form-group col-sm-12">
        <label>{{ lang.daysnotify }}</label>
        <input type="text" class="form-control" formControlName="days_notify" [ngClass]="formErrorClass(createForm.controls.days_notify, createFormSubmitted)">

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.days_notify, value:createForm.controls.days_notify, submitted:createFormSubmitted }"></ng-template>

        <div *ngIf="createForm.controls.days_notify.touched && createForm.hasError('rangeval')" style="color: #ff7b76;">{{ lang.daysnotifyError }}
        </div>
      </div>

      <div class="col-sm-12">
        <label>{{ lang.notificationTime }}</label>

        <select class="form-control" formControlName="time_notify" [ngClass]="formErrorClass(createForm.controls.time_notify, createFormSubmitted)">
          <option value="">Select Time</option>
          <option *ngFor="let type of notification_time" [ngValue]="type">{{type}}</option>
        </select> 

        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.time_notify, value:createForm.controls.time_notify, submitted:createFormSubmitted }"></ng-template>

      </div>  </div>


  </div>
     
  <div class="modal-footer">
    <div  *ngIf="rolepermission;then content else other_content"></div>    

    <ng-template #other_content><button type="submit" class="btn btn-success">{{ lang.save }}</button></ng-template>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang.close }}</button>
  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>

